import * as type from '../actions/types';

const initialState = {
  fetching: false,
  error: false,
  errorMessage: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case type.FETCH_IMPORT_OPTIONS_PENDING: {
      return {
        ...state,
        fetching: true,
        error: false,
        errorMessage: '',
      };
    }

    case type.FETCH_IMPORT_OPTIONS_SUCCESS: {
      return {
        ...state,
        fetching: false,
        error: false,
        errorMessage: '',
      };
    }

    case type.FETCH_IMPORT_OPTIONS_FAILURE: {
      return {
        ...state,
        fetching: false,
        error: true,
        errorMessage: action.payload,
      };
    }

    default: {
      return state;
    }
  }
}
